/*
  Masterclass v2
  1. Buttons [data-mc-cta]: smooth scroll to the form, dataLayer "masterclass_cta_click".
  2. Countdown [data-mc-countdown data-at]: days/hours/min/sec, hidden once started.
  3. Sticky mobile bar [data-mc-sticky]: shows after the hero, hides while a form is visible.
  4. Add to calendar [data-mc-cal]: Google link + downloadable .ics built from the start time.
  5. WebinarJam: when its iframe reports a successful registration (it posts a "redirect"
     message to the page), push dataLayer "masterclass_registration" before it redirects.
     Use GTM tags with beacon transport so they fire before the page changes.
*/
(() => {
    if (window.QOTTmc) return;
    window.QOTTmc = true;
    window.dataLayer = window.dataLayer || [];
    const pageName = (document.querySelector('.mc2-hero__title') || {}).textContent || document.title;
    const masterclass = pageName.replace(/\s+/g, ' ').trim();

    // 0. WebinarJam: load each embed script once (it fills every wrapper with its hash)
    const loaded = new Set();
    document.querySelectorAll('[data-mc-wj-src]').forEach((w) => {
        const hash = w.getAttribute('data-webinar-hash');
        if (loaded.has(hash)) return;
        loaded.add(hash);
        const sc = document.createElement('script');
        sc.src = w.getAttribute('data-mc-wj-src');
        w.appendChild(sc);
    });

    // 1. CTA buttons
    document.addEventListener('click', (e) => {
        const a = e.target.closest('a[data-mc-cta]');
        if (!a) return;
        window.dataLayer.push({ event: 'masterclass_cta_click', masterclass, cta_location: a.dataset.mcCta, cta_text: a.textContent.trim() });
        const hash = (a.getAttribute('href') || '').split('#')[1];
        if (!hash || (a.pathname && a.pathname !== location.pathname)) return;
        let target = document.getElementById(hash);
        // #register: prefer the form in the hero if it is the one on screen above
        if (!target && hash === 'register') target = document.getElementById('register-hero');
        if (!target) return;
        e.preventDefault();
        const form = target.querySelector('[data-mc-form]') || target;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        form.classList.remove('is-flash'); void form.offsetWidth; form.classList.add('is-flash');
        try { history.replaceState(null, '', '#' + hash); } catch (err) {}
    });

    // 2. Countdown
    const pad = (n) => String(n).padStart(2, '0');
    document.querySelectorAll('[data-mc-countdown]').forEach((el) => {
        const at = Date.parse(el.dataset.at);
        if (isNaN(at)) return;
        const parts = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
        const tick = () => {
            let left = Math.floor((at - Date.now()) / 1000);
            if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
            const d = Math.floor(left / 86400); left -= d * 86400;
            const h = Math.floor(left / 3600); left -= h * 3600;
            const m = Math.floor(left / 60); const s = left - m * 60;
            parts.d.textContent = d; parts.h.textContent = pad(h); parts.m.textContent = pad(m); parts.s.textContent = pad(s);
            el.hidden = false;
        };
        const timer = setInterval(tick, 1000);
        tick();
    });

    // 3. Sticky bar
    const bar = document.querySelector('[data-mc-sticky]');
    const hero = document.querySelector('[data-mc-hero]');
    if (bar && hero && 'IntersectionObserver' in window) {
        let heroVisible = true; let formVisible = false;
        const update = () => { bar.hidden = heroVisible || formVisible; document.body.classList.toggle('mc2-has-sticky', !bar.hidden); };
        new IntersectionObserver(([en]) => { heroVisible = en.isIntersecting; update(); }).observe(hero);
        const forms = document.querySelectorAll('[data-mc-register], #register-hero');
        const seen = new Map();
        const fo = new IntersectionObserver((ens) => {
            ens.forEach(en => seen.set(en.target, en.isIntersecting));
            formVisible = [...seen.values()].some(Boolean); update();
        });
        forms.forEach(f => fo.observe(f));
    }

    // 4. Add to calendar
    const utc = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    document.querySelectorAll('[data-mc-cal]').forEach((el) => {
        const start = new Date(el.dataset.start);
        if (isNaN(start)) { el.hidden = true; return; }
        const end = new Date(start.getTime() + (parseInt(el.dataset.minutes, 10) || 60) * 60000);
        const title = el.dataset.title || masterclass;
        const details = (el.dataset.details || '') + '\n' + location.href.split('#')[0];
        const loc = el.dataset.location || '';
        const g = el.querySelector('[data-mc-cal-google]');
        if (g) g.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) +
            '&dates=' + utc(start) + '/' + utc(end) + '&details=' + encodeURIComponent(details) + '&location=' + encodeURIComponent(loc);
        const ics = el.querySelector('[data-mc-cal-ics]');
        if (ics) ics.addEventListener('click', (e) => {
            e.preventDefault();
            const esc = (t) => String(t).replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n');
            const body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Queen of the Thrones//Masterclass//EN', 'BEGIN:VEVENT',
                'UID:' + utc(start) + '-' + Math.random().toString(36).slice(2) + '@queenofthethrones.com', 'DTSTAMP:' + utc(new Date()),
                'DTSTART:' + utc(start), 'DTEND:' + utc(end), 'SUMMARY:' + esc(title), 'DESCRIPTION:' + esc(details), 'LOCATION:' + esc(loc),
                'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(title), 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
            const url = URL.createObjectURL(new Blob([body], { type: 'text/calendar' }));
            const a = document.createElement('a'); a.href = url; a.download = title.replace(/[^\w]+/g, '-').replace(/^-|-$/g, '') + '.ics';
            document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 30000);
        });
        el.addEventListener('click', (e) => {
            const link = e.target.closest('a');
            if (link) window.dataLayer.push({ event: 'masterclass_add_to_calendar', masterclass, calendar: link.hasAttribute('data-mc-cal-ics') ? 'ics' : 'google' });
        });
    });

    // 5. WebinarJam registration
    let registered = false;
    window.addEventListener('message', (e) => {
        if (registered || !/webinarjam/i.test(e.origin || '')) return;
        let data = e.data;
        if (typeof data === 'string') { try { data = JSON.parse(data); } catch (err) { data = { raw: data }; } }
        const flat = JSON.stringify(data || {}).toLowerCase();
        if (flat.indexOf('redirect') === -1) return;
        registered = true;
        const wrap = document.querySelector('[data-mc-form] [data-webinar-hash]');
        window.dataLayer.push({ event: 'masterclass_registration', masterclass, webinar_hash: wrap ? wrap.getAttribute('data-webinar-hash') : '' });
    });

    window.dataLayer.push({ event: 'masterclass_view', masterclass });
})();
